<template>
  <div class="container-fluid">
    <b-card no-body class="card-transparent-background">
      <b-card-title class="card-title-doom-yoga">
        Subscriptions and Packs
      </b-card-title>
    </b-card>

    <div class="">
      <b-tabs class="evnetTypesTabs">
        <b-tab
          title="SMS"
          title-link-class="btn btn-bumblebee btn-doomyoga btn-tab btn-doomyoga-secondary"
          lazy
          active
        >
          <DoomYogaSMS />
        </b-tab>
        <!--        
        <template #tabs-end>
          <li
            role="presentation"
            class="nav-item custom-nav-item-right"
          >
            <b-button
              variant="doomyoga-primary"
              class="btn-bumblebee btn-doomyoga btn-filter"
            >
              Create New Membership
            </b-button>
          </li>
        </template> -->
      </b-tabs>
    </div>
  </div>
</template>

<script>
import DoomYogaSMS from "./SMS.vue";

export default {
  name: "DoomYogaMarketing",
  components: { DoomYogaSMS },
  data() {
    return {
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/admin/marketing/Index.vue